import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-icloud',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>iCloud icon</title><path d="M13.762 4.29a6.51 6.51 0 0 0-5.669 3.332 3.571 3.571 0 0 0-1.558-.36 3.571 3.571 0 0 0-3.516 3A4.918 4.918 0 0 0 0 14.796a4.918 4.918 0 0 0 4.92 4.914 4.93 4.93 0 0 0 .617-.045h14.42c2.305-.272 4.041-2.258 4.043-4.589v-.009a4.594 4.594 0 0 0-3.727-4.508 6.51 6.51 0 0 0-6.511-6.27z"/></svg>`,
    styles: []
})
export class SimpleIconsIcloudComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#3693F3';
    @Input() className: string = 'simple-icons-icloud'
    constructor() {}
    ngOnInit(): void {}
}
